import React from 'react';
import { FiMail } from 'react-icons/fi';
import EmailQueueDashboard from '../components/email/EmailQueueDashboard';
import './EmailQueue.css';

const EmailQueue = () => {
  return (
    <div className="email-queue-page list-page">
      <div className="page-header">
        <h1><FiMail /> Email queue</h1>
      </div>
      <EmailQueueDashboard />
    </div>
  );
};

export default EmailQueue;
